const {
    GET_CASH_FLOW_REPORT,
    CASH_FLOW_REPORT_NOTIFICATION,
  } = require('redux/admin-constants');

  const initialState = {
    cashFlowReport: [],
    cashFlowReportNotification: {
      message: '',
      isSuccess: 1,
    },
  }; 

  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_CASH_FLOW_REPORT: {
        return {
          ...state,
          cashFlowReport: payload,
        };
      }
     
      case CASH_FLOW_REPORT_NOTIFICATION: {
        return {
          ...state,
          cashFlowReportNotification: payload.message
            ? payload
            : initialState.cashFlowReportNotification,
        };
      }
      default:
        return state;
    }
  };
  
  export default reducer;